module.exports = __webpack_public_path__ + "assets/img/car11.fd367b0b.png";